import React from 'react';
import cls from 'classnames';
import { prefixCls } from '../type';
import './inOption.scss';
const InSingleOption = (props) => {
    const { children, className } = props;
    return (React.createElement("div", { className: cls(className, `${prefixCls}-single`) },
        React.createElement("div", { className: `${prefixCls}-front` }, React.isValidElement(children) || typeof children === 'string' ? children : props.value)));
};
export default InSingleOption;
